// TSS vite/03 §"Query keys convention".

export const saleKeys = {
    all:  ['sales'],
    list: (filters) => ['sales', 'list', filters],
    infinite: (filters, limit) => ['sales', 'list', 'infinite', filters, limit],
    // Historial de abonos de una venta (Q-199). Prefijo 'sales' → invalidar
    // saleKeys.all también refresca los abonos.
    payments: (saleId) => ['sales', 'payments', saleId],
};
